import {useQueries} from '@tanstack/react-query'
import {getProductCategoryList} from '@/services/ProductsService/ProductCategory/category'

// dropdowns/categories returns { data: [{ id, en }] }; map to { categoryId, category } for consumers
export const useProductCategoryList = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ['CATEGORY_LIST'],
        queryFn: getProductCategoryList,
      },
    ],
  })

  const response = results?.[0]?.data
  const list = response?.data ?? []
  const categoryListData = list.map(item => ({
    categoryId: item.id,
    category: item.en,
  }))

  return {
    categoryListData,
  }
}
